import { ConsultationStepData } from "../types/type";

export const consultationStepsData: ConsultationStepData[] = [
  {
    title: "Choose Your Medication",
    description: "Select the medication that's right for your weight loss journey.",
    form: [
      {
        name: "medication",
        label: "Medication",
        type: "radio",
        options: ["Liraglutide", "Tirzepatide", "Semaglutide"],
        required: true,
      },
    ],
  },
  {
    title: "Select Consultation Type",
    description: "Choose how you'd like to connect with our medical professionals.",
    form: [
      {
        name: "consultationType",
        label: "Consultation Type",
        type: "radio",
        options: ["express", "live"],
        required: true,
      },
    ],
  },
]
